// Configuración base (solo textos y plantilla por defecto)
export const emailConfig = {
  // Valores por defecto (se sobrescriben con localStorage si existen)
  publicKey: 'TU_PUBLIC_KEY_AQUI',
  serviceId: 'TU_SERVICE_ID_AQUI',
  templateId: 'TU_TEMPLATE_ID_AQUI',

  testEmailTemplate: {
    from_name: 'Tu Empresa',
    from_email: 'no-reply@tuempresa.com',
    to_email: '',
    subject: 'Test de configuración de email - FactuApp',
    message: `
      ¡Hola!

      Este es un email de prueba del sistema de facturación.

      Si recibes este mensaje, significa que la configuración SMTP/EmailJS está funcionando correctamente.

      Detalles del test:
      - Fecha y hora: {{current_datetime}}
      - Sistema: Dashboard de Facturas

      Saludos,
      Tu equipo
    `
  }
};

// Lee claves EmailJS guardadas en localStorage
export const getEmailJSKeys = (): { publicKey?: string; serviceId?: string; templateId?: string } => {
  try {
    const raw = localStorage.getItem('emailjsConfig');
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return {
      publicKey: parsed.publicKey,
      serviceId: parsed.serviceId,
      templateId: parsed.templateId
    };
  } catch {
    return {};
  }
};

export const isEmailConfigured = (): boolean => {
  const { publicKey, serviceId } = getEmailJSKeys();
  return Boolean(publicKey && serviceId);
};

export const getEmailConfigStatus = () => {
  const { publicKey, serviceId, templateId } = getEmailJSKeys();
  return {
    publicKey: publicKey ? '✅ Configurado' : '❌ Pendiente',
    serviceId: serviceId ? '✅ Configurado' : '❌ Pendiente',
    templateId: templateId ? '✅ Configurado' : '⚠️ Pendiente (opcional por ahora)',
    isReady: Boolean(publicKey && serviceId)
  };
}; 